import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as DropdownSVG } from "go-core/images/svg/dropdown.svg";
import { ExternalProviderMenuApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import MenuExternalPortalMenuItem from "./MenuExternalPortalMenuItem";

interface Props {
	category: ExternalProviderMenuApi;
}

const MenuExternalPortalMenuCategory = ({ category }: Props) => {
	const { t } = useTranslation();
	const [expandItems, setExpandItems] = useState(false);
	const isMobile = useWindowSize().isMobile;

	return (
		<>
			<tr>
				<td>
					<div
						className={`d-flex align-items-center gap-2 ${
							category.items.length > 0 ? "cursor-pointer" : ""
						}`}
						onClick={() => setExpandItems((prevState) => !prevState)}
					>
						{category.items.length > 0 && (
							<DropdownSVG className={`dropdown-icon ${expandItems ? "--expanded" : ""}`} />
						)}
						<p className="mb-0 text-primary font-weight-bold">{category.name}</p>
					</div>
				</td>
				<td />
				<td className="action">
					{/*{!isMobile ? (*/}
					{/*	<Button variant="add" className="mb-0">*/}
					{/*		{t("lib:common.action.edit")}*/}
					{/*	</Button>*/}
					{/*) : (*/}
					{/*	<span className="cursor-pointer text-primary">{t("lib:common.action.edit")}</span>*/}
					{/*)}*/}
				</td>
			</tr>
			{expandItems &&
				category.items.map((item, index) => (
					<MenuExternalPortalMenuItem
						rawItem={item}
						withImage
						key={index}
						name={item.name}
						description={item.description}
						price={item.price}
						level={0}
						paddingLeft={24}
						imageUrl={item.image_url}
					/>
				))}
		</>
	);
};

export default MenuExternalPortalMenuCategory;
